"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiRadio = _interopRequireDefault(require("@tencent/spaui-radio"));

var _classnames = _interopRequireDefault(require("classnames"));

var _info = _interopRequireDefault(require("./info"));

var _radiogroup_props = require("./radiogroup_props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var RadioGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(RadioGroup, _PureComponent);

  function RadioGroup() {
    _classCallCheck(this, RadioGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(RadioGroup).apply(this, arguments));
  }

  _createClass(RadioGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          data = _this$props.data,
          value = _this$props.value,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled,
          _this$props$RadioProp = _this$props.RadioProps,
          RadioProps = _this$props$RadioProp === void 0 ? {} : _this$props$RadioProp,
          vertical = _this$props.vertical,
          theme = _this$props.theme,
          showSeparator = _this$props.showSeparator,
          SeparatorComponent = _this$props.SeparatorComponent,
          _this$props$tipFieldN = _this$props.tipFieldName,
          tipFieldName = _this$props$tipFieldN === void 0 ? '' : _this$props$tipFieldN,
          useNewUI = _this$props.useNewUI;
      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])('spaui-radio-group', {
          'with-vertical': vertical,
          'simple-radio': theme === 'check',
          'use-newui': useNewUI
        })
      }, RadioGroup), data.map(function (item, index) {
        var result = [];
        var radioProps = {}; // 复制下，避免下方添加的属性被引用了

        radioProps = (0, _spauiUtils.objectAssign)({}, item); // 去掉不需要的属性

        delete radioProps.children;
        delete radioProps.onChange;
        delete radioProps.checked;

        if (name) {
          radioProps.name = name;
        }

        if (disabled) {
          radioProps.disabled = true;
        }

        var radioAllProps = _objectSpread({}, RadioProps, {}, radioProps); // 如果有字段提示字段名，就替换一下


        if (tipFieldName) {
          radioAllProps.tip = radioAllProps[tipFieldName];
        } // 添加单选框


        result.push(_react["default"].createElement(_spauiRadio["default"], _extends({}, radioAllProps, {
          key: "".concat(item.value, "_radio"),
          checked: value === item.value,
          onChange: onChange
        }), item.children)); // 添加下附加内容

        if (typeof item.addon !== 'undefined') {
          if (_react["default"].isValidElement(item.addon)) {
            result.push((0, _react.cloneElement)(item.addon, {
              key: "".concat(item.value, "_addon")
            }));
          } else {
            result.push(item.addon);
          }
        } // 添加分割符


        if (showSeparator && !vertical && index !== data.length - 1) {
          result.push(_react["default"].createElement(SeparatorComponent, {
            key: "".concat(item.value, "_separator")
          }));
        }

        return result;
      }));
    }
  }]);

  return RadioGroup;
}(_react.PureComponent); // 组件标记


_defineProperty(RadioGroup, "propTypes", _radiogroup_props.propTypes);

_defineProperty(RadioGroup, "defaultProps", _radiogroup_props.defaultProps);

(0, _spauiUtils.setComponentMark)(RadioGroup, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = RadioGroup;
exports["default"] = _default;